<template>
  <ProductPrice
      v-if="product.active"
      :price-vat="product.price_vat"
      :price-default-vat="product.price_default_vat"
      :discount-start="product.discount_start"
      :discount-end="product.discount_end"
      :good-price="product.good_price"
      :show-installment="false"
  />
  <div v-if="product.good_price" class="text-xs mt-3">
    {{ __('Hea hind märgisega toodetele ei kehti täiendavad soodustused ega kampaaniad.')}}
  </div>
  <div class="divider my-2"></div>
  <ProductShipping
      v-if="product.active"
      :stocklevel="product.stocklevel"
      :interim-stocklevel="product.interim_stocklevel"
      :shipping-time="product.shipping_time"
  />
  <div v-else>
    {{ __("Valikust väljas") }}
  </div>
  <a
      v-if="product.active"
      href="#"
      class="add-to-cart btn w-full my-4 text-white btn-info"
      @click.prevent="addToCart"
  >
    {{ __("Lisa ostukorvi") }}
  </a>
  <template v-if="product.active && product.services.length > 0">
    <h3 class="text-lg font-semibold">{{ __("Lisateenused") }}</h3>
    <div v-for="(service, idx) in product.services" :key="idx" class="form-control">
      <label class="label cursor-pointer">
        <input
            :id="'service-' + service.id"
            type="checkbox"
            :checked="cartServices.some((s) => s.product.id === service.product.id)"
            class="checkbox"
            @change="toggleService($event, service.product.id)"
        >
        <span class="ml-2.5 label-text text-base">
                {{ trField(service.product, "title") }}
                <strong>{{ price(service.price) }}</strong>
              </span>
      </label>
    </div>
  </template>

  <template v-if="product.active && installment(product.price_vat)">
    <div class="divider my-2"></div>
    <h3 class="text-lg font-semibold">{{ __("Paindlik järelmaks") }}</h3>
    <label class="form-control">
              <span class="label">
                <span class="label-text">{{ __("Sissemakse") }}</span>
              </span>
      <select
          v-model="downPayment"
          name="down_payment"
          class="select select-bordered"
      >
        <option
            v-for="(dp, idx) in downPayments()"
            :key="idx"
            :value="dp.amount"
        >
          {{ dp.percent }} % ({{ price(dp.amount) }})
        </option>
      </select>
    </label>
    <label class="my-2 form-control">
              <span class="label">
                <span class="label-text">{{ __("Järelmaksu periood") }}</span>
              </span>
      <select
          v-model="period"
          name="period"
          class="select select-bordered"
      >
        <option
            v-for="(month, idx) in loanMonths()"
            :key="idx"
            :value="month"
        >
          {{ month }} {{ __("kuud") }}
        </option>
      </select>
    </label>
    <a
        href="#"
        class="add-to-cart my-2 btn bg-gray-300 w-full"
        @click.prevent="addToCart"
    >
      {{ __("Kuumakse") }}
      <span class="monthly-payment calculate">
                {{ calculatedPayment }}
              </span>
    </a>
    <div>
      {{ __("Järelmaksu taotluse saate esitada tellimust vormistades.") }}
    </div>
  </template>
</template>

<script setup>
import {__, installment, loan, loanDownPayments, loanMonths, price, toCart, trField, trRoute} from "../utils.js";
import ProductPrice from "../components/ProductPrice.vue";
import ProductShipping from "../components/ProductShipping.vue";
import {computed, ref} from "vue";
import {router} from "@inertiajs/vue3";

const props = defineProps({
  product: Object,
  cartServices: Array,
});

const downPayment = ref(0);
const period = ref(48);
const addToCart = () => toCart({id: props.product.id, show_modal: true});
const calculatedPayment = computed(() =>
    loan(props.product.price_vat, period.value, downPayment.value)
);
const downPayments = () => loanDownPayments(props.product.price_vat);
const toggleService = (event, productId) => router.post(trRoute("cart"), {
  id: productId,
  row_product_id: props.product.id,
  product: true,
  checked: event.target.checked
});
</script>